import { defineGameCard } from '../authoring/index.js';
export const FourLeggedChairCard = defineGameCard({
    id: 'four_legged_chair',
    gameplay: {
        type: 'UNIT',
        cost: 3,
        baseStats: { attack: 4, health: 4 },
        combatDamageParts: 4,
        combatDamageOverflow: 'to_player',
    },
    presentation: {
        name: 'Стул на четырёх ножках',
        description: 'Наносит боевой урон четырьмя последовательными ударами. После уничтожения цели оставшиеся удары наносят урон игроку. Если Стул погибает, серия прерывается.',
        glyph: {
            colors: ['#10213A', '#8E4632', '#673026', '#944934', '#A9533C'],
            rows: [
                '........11..........',
                '.......1221.........',
                '......12221.........',
                '.....122321.........',
                '.....132331.........',
                '.....133331.........',
                '.....133331.........',
                '.....13333411.......',
                '.....1333222411.....',
                '.....133222445511...',
                '.....1322244445551..',
                '.....1322444444451..',
                '.....1514444444431..',
                '.....1511144444131..',
                '.....1511311541131..',
                '.....151131151.131..',
                '.....151.1.151.131..',
                '......1....151..1...',
                '...........151......',
                '............1.......',
            ],
        },
    },
    role: 'playable',
    ui: {
        mechanics: ['multi_hit'],
    },
});
//# sourceMappingURL=four_legged_chair.js.map